<div class="progress-bar-container">
  <!-- Barre de progression linéaire -->
  <div class="progress-header mb-6">
    <div class="flex items-center justify-between mb-3">
      <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide">
        Votre progression
      </h3>
      <span class="text-xs font-bold text-purple-600 bg-purple-50 dark:bg-purple-900/20 px-3 py-1 rounded-full">
        {{ currentStep() }} / {{ totalSteps() }}
      </span>
    </div>

    <!-- Barre de progression -->
    <div class="progress-track">
      <div
        class="progress-fill"
        [style.width.%]="progress"
        [ngClass]="{
          'progress-fill-complete': currentStep() === totalSteps(),
        }"
      ></div>
    </div>
  </div>

  <!-- Indicateurs d'étapes -->
  <div class="steps-container">
    <!-- Affichage mobile : étape actuelle uniquement -->
    <div class="md:hidden mb-6">
      <div class="bg-white dark:bg-slate-800 rounded-lg p-4 border-2 border-purple-600">
        <div class="text-center">
          <div class="text-3xl mb-2">{{ steps[currentStep() - 1].icon }}</div>
          <h4 class="text-lg font-bold text-gray-900 dark:text-white">
            {{ steps[currentStep() - 1].label }}
          </h4>
          <p class="text-xs text-gray-600 dark:text-gray-400 mt-1">
            Étape {{ currentStep() }} sur {{ totalSteps() }}
          </p>
        </div>
      </div>
    </div>

    <!-- Affichage desktop : toutes les étapes -->
    <div class="hidden md:grid steps-grid">
      @for (step of steps; track step; let i = $index) {
        <div
          class="step-item"
        [ngClass]="{
          'step-completed': isStepCompleted(step.step),
          'step-current': isStepCurrent(step.step),
          'step-upcoming': isStepUpcoming(step.step),
        }"
          >
          <!-- Connecteur vers l'étape suivante -->
          @if (i < steps.length - 1) {
            <div
              class="step-connector"
          [ngClass]="{
            'step-connector-filled': isStepCompleted(step.step),
          }"
            ></div>
          }
          <!-- Cercle de l'étape -->
          <div class="step-circle">
            <div class="step-circle-inner">
              <!-- Checkmark pour étapes complétées -->
              @if (isStepCompleted(step.step)) {
                <svg
                  class="step-checkmark"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              }
              <!-- Emoji pour étape actuelle ou à venir -->
              @if (!isStepCompleted(step.step)) {
                <span class="step-icon">
                  {{ step.icon }}
                </span>
              }
            </div>
          </div>
          <!-- Label de l'étape -->
          <div class="step-label">
            <p class="step-label-text">{{ step.label }}</p>
            <p class="step-label-number">Étape {{ step.step }}</p>
          </div>
        </div>
      }
    </div>
  </div>

</div>